import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { skillStorageUtil as storageUtil } from '../../services/storageUtil';
import { loadBuildFulfilled } from './skillLoadSlice';

const makeBuild = (name: string, state: RootState) => {
  const trainer = state.skillTrainer;
  return {
    name,
    date: new Date().toISOString(),
    strn: trainer.strn,
    intl: trainer.intl,
    wilp: trainer.wilp,
    dext: trainer.dext,
    cont: trainer.cont,
    raceId: trainer.raceId,
    professionId: trainer.professionId,
    skills: trainer.skills
      .filter(x => x.percentTarget)
      .map(x => ({ id: x.id, percentTarget: x.percentTarget }))
  };
}

export const saveBuild = (name: string): AppThunk => (dispatch, getState) => {
  const build = makeBuild(name, getState());
  storageUtil.saveBuild(name, build);
  dispatch(slice.actions.saveBuildFulfilled(build));
};

const initialState: SkillSaveState = {
  visible: false,
  name: ''
};

export interface SkillSaveState {
  visible: boolean;
  name: string;
}

export const slice = createSlice({
  name: 'skillSave',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    },
    saveBuildFulfilled: (state, action: PayloadAction<any>) => {
      state.name = action.payload.name;
      state.visible = false;
    }
  },
  extraReducers: builder => {
    builder.addCase(loadBuildFulfilled, (state, action) => {
      state.name = action.payload.name;
    });
  }
});

export default slice.reducer;
export const { show, hide, saveBuildFulfilled } = slice.actions;
